"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiAlert = _interopRequireDefault(require("@tencent/spaui-alert"));

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

var _notice_props = require("./notice_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import Animate from '@tencent/od-animate';
// 消息类型 type 调整
var compactMap = {
  warn: 'warning',
  error: 'danger',
  strongwarn: 'danger'
};
/**
 * @class
 * 消息通知组件
 */

var Notice =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Notice, _PureComponent);

  function Notice(props) {
    var _this;

    _classCallCheck(this, Notice);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Notice).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onManualClose", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          removeNotice = _this$props.removeNotice;
      removeNotice(id, false);
    });

    _this.state = {};
    return _this;
  } // 手动关闭弹框


  _createClass(Notice, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          message = _this$props2.message,
          type = _this$props2.type,
          className = _this$props2.className,
          theme = _this$props2.theme,
          canBackout = _this$props2.canBackout,
          backoutLabel = _this$props2.backoutLabel,
          onClickBackout = _this$props2.onClickBackout,
          closable = _this$props2.closable,
          AlertProps = _this$props2.AlertProps,
          backoutButtonProps = _this$props2.backoutButtonProps,
          closeButtonProps = _this$props2.closeButtonProps,
          _this$props2$style = _this$props2.style,
          style = _this$props2$style === void 0 ? {} : _this$props2$style;
      var messageType = compactMap[type] || type;
      return _react["default"].createElement("div", {
        className: "spaui-message-wrapper"
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('spaui-message', className, (_classNames = {}, _defineProperty(_classNames, "spaui-message-".concat(messageType), messageType), _defineProperty(_classNames, "spaui-message-".concat(theme), theme), _defineProperty(_classNames, 'with-action', canBackout || closable), _classNames)),
        style: style
      }, _react["default"].createElement("div", {
        className: "spaui-message-inner"
      }, _react["default"].createElement("div", {
        className: "spaui-message-content"
      }, _react["default"].createElement(_spauiAlert["default"], _extends({
        type: type,
        message: message
      }, AlertProps))), canBackout || closable ? _react["default"].createElement("div", {
        className: "spaui-message-action"
      }, canBackout ? _react["default"].createElement("button", _extends({
        type: "button",
        className: "spaui-message-btn spaui-message-backout",
        onClick: onClickBackout
      }, backoutButtonProps), backoutLabel) : null, closable ? _react["default"].createElement("button", _extends({
        type: "button",
        className: "spaui-message-btn spaui-message-close",
        onClick: this.onManualClose
      }, closeButtonProps), _react["default"].createElement(_spauiIcon["default"], {
        name: "close-normal-outlined"
      })) : null) : null)));
    }
  }]);

  return Notice;
}(_react.PureComponent);

_defineProperty(Notice, "propTypes", _notice_props.propTypes);

_defineProperty(Notice, "defaultProps", _notice_props.defaultProps);

var _default = Notice;
exports["default"] = _default;